import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    CardFooterDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import type {
    CardFooterAlign,
    CardSize
} from "../../type";
import {
    getFooterBandStyle
} from "../../../../helpers/theme/footerBand";

export const CARD_FOOTER_ALIGNMENTS: Record<CardFooterAlign, NonNullable<ViewStyle["justifyContent"]>> = {
    between: "space-between",
    stretch: "flex-start",
    start: "flex-start",
    end: "flex-end"
};

export const CARD_FOOTER_ACTION_SIZES: Record<CardSize, keyof NCoreUIKit.ControlHeights> = {
    medium: "medium",
    small: "small"
};

export const CARD_FOOTER_ACTION_SKELETON_RATIO = 3;

export const CARD_FOOTER_TEXT_SKELETON_RATIO = 2;

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    inert: {
        pointerEvents: "none"
    },
    stretched: {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0
    }
});

export const useStyles = ({
    shapeConfigs,
    isDivided,
    radiuses,
    borders,
    variant,
    colors,
    spaces,
    align,
    inset
}: CardFooterDynamicStyleType) => {
    const styles = {
        container: {
            justifyContent: CARD_FOOTER_ALIGNMENTS[align],
            paddingHorizontal: inset,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    if(variant === "band") {
        Object.assign(styles.container, getFooterBandStyle({
            surfaceBorderWidth: borders.line,
            outerRadius: radiuses.surface,
            shapeConfigs,
            borders,
            colors,
            spaces,
            inset
        }));

        return styles;
    }

    if(isDivided) {
        Object.assign(styles.container, {
            borderTopColor: colors.content.border.subtle,
            borderTopWidth: borders.separator,
            paddingTop: inset
        });
    }

    return styles;
};
export default stylesheet;
